import React, { useState } from 'react';
import { Thumbnail } from '@bynder/design-system';
import { useActiveWidget } from '../../../../queries/guides';
import { SpacerWidget, WIDGET_TYPE } from '../../../../types';
import { useSpacerWidgetMutations } from '../../../../mutations/widgets/spacer';
import { WidgetSettingsHeader } from '../../Styles';
import { useInspectorStore } from '../../../../stores/inspectorStore';
import CustomCssStyleEditor from '../CustomCSSEditor';
import { isDevelopment } from '../../../../constants/app';
import SpacerWidgetDividerTabs from './SpacerWidgetSettings/SpacerWidgetDividerTabs';
import SpacerHeightEditor from './SpacerWidgetSettings/SpacerWidgetHeightEditor';
import SpacerColorPicker from './SpacerWidgetSettings/SpacerWidgetColorPicker';
import { SettingsAccordion } from '../SettingsAccordion';
import { IconBorderRadius } from '@bynder/icons';
import { useTranslate } from '@bynder/localization';

export const SpacerWidgetSettings: React.FC = () => {
  const { translate } = useTranslate();
  const widgetSettings = useInspectorStore(s => s.widgetSettings);
  const { updateSpacerWidget, resizeSpacerWidget, editStyleInSpacerWidget } =
    useSpacerWidgetMutations(
      widgetSettings.sectionId,
      widgetSettings.columnIndex,
      widgetSettings.widgetId,
    );

  const widget = useActiveWidget() as SpacerWidget;
  const [style, setStyle] = useState(widget?.style.stylesheet || '');

  const handleStyleChange = (value: string) => {
    setStyle(value);
    editStyleInSpacerWidget.mutate({ newStyle: value });
  };

  return (
    <>
      <WidgetSettingsHeader widgetType={WIDGET_TYPE.SPACER} />

      <SettingsAccordion
        title={translate('WIDGET_INSPECTOR.SPACER_WIDGET_PROPERTIES')}
        thumbnail={<Thumbnail icon={<IconBorderRadius />} />}
      >
        <SpacerWidgetDividerTabs
          divider={widget?.divider}
          updateSpacerWidget={updateSpacerWidget}
        />
        <SpacerHeightEditor
          height={widget.height}
          onChange={resizeSpacerWidget}
        />
      </SettingsAccordion>
      <SpacerColorPicker
        style={widget?.style.stylesheet}
        handleStyleChange={handleStyleChange}
      />
      {isDevelopment && (
        <CustomCssStyleEditor
          label="Custom CSS"
          placeholder="Enter your custom CSS here"
          style={style}
          handleChange={handleStyleChange}
        />
      )}
    </>
  );
};
